<template>
  <div>
    <div class="card-container">
      <div class="card-title">
        运营小区考核筛选
      </div>
      <div class="card-content">
        <a-form ref="detailForm" class="detail-form" :form="form">
          <a-row>
            <a-col class="search-item" :span="6">
              <a-form-item label="区域" v-bind="formItemLayout">
                <a-cascader
                  v-model="region"
                  :options="options"
                  :load-data="loadData"
                  change-on-select
                  :field-names="{
                    label: 'name',
                    value: 'id',
                    children: 'children'
                  }"
                  placeholder="省市区、街道"
                  @change="changeArea"
                />
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="6">
              <a-form-item label="小区" v-bind="formItemLayout">
                <a-select
                  v-decorator="['estateId']"
                  allow-clear
                  show-search
                  placeholder="全部"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="(item, index) in estateList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.housingEstate }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col class="search-item" :span="4" align="right">
              <a-button type="primary" class="mr8" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetForm">
                重置
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </div>
    <div class="card-container mrt16">
      <a-row>
        <a-col :span="12">
          <div class="card-title">
            运营小区考核排名列表
          </div>
        </a-col>
      </a-row>
      <div class="card-content">
        <a-table
          class="table-content"
          :columns="columns"
          :data-source="formData"
          :loading="loading"
          :pagination="pagination"
          :row-key="record => record.id"
          :scroll="{ x: 1500 }"
          @change="handleTableChange"
        >
          <template slot="rownum" slot-scope="text">
            <span v-if="text === 1">
              <IconFont
                type="icondiyiming"
                style="font-size: 20px;"
              />
            </span>
            <span v-else-if="text === 2">
              <IconFont
                type="icondierming"
                style="font-size: 20px;"
              />
            </span>
            <span v-else-if="text === 3">
              <IconFont
                type="icondisanming"
                style="font-size: 20px;"
              />
            </span>
            <span v-else style="margin-left:6px;">{{ text }}</span>
          </template>
          <template slot="scenario" slot-scope="text">
            <span>{{ text | scenarioFl }}</span>
          </template>
          <div slot="action" slot-scope="record" class="btn-list">
            <a-button
              class="table-btn-link"
              type="link"
              size="small"
              @click="toView(record)"
            >
              查看详情
            </a-button>
          </div>
        </a-table>
      </div>
    </div>
    <a-modal
      v-model="visible"
      title="查看详情"
      :width="1250"
      centered
      :footer="false"
      @cancel="cancel"
    >
      <div id="mountNode" :style="{width: '100%', height: '450px'}"></div>
    </a-modal>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {
  getArea,
  getEstate,
  iconFontComponent
} from '@/components/mixins/mixins.js'
import { getAssessList, getDetail } from '@/api/assessNew'
const columns = [
  {
    title: '排名',
    dataIndex: 'rownum',
    scopedSlots: { customRender: 'rownum' },
    width: 100
  },
  {
    title: '区域名称',
    dataIndex: 'areaName'
  },
  {
    title: '街道名称',
    dataIndex: 'street'
  },
  {
    title: '小区名称',
    dataIndex: 'estateName'
  },
  {
    title: '昨日运营得分均值',
    dataIndex: 'device'
    // customRender (text, record, index) {
    //   if (text) {
    //     return text + '分'
    //   } else {
    //     return '-'
    //   }
    // }
  },
  {
    title: '更新时间',
    dataIndex: 'lastTime'
  },
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 120,
    scopedSlots: { customRender: 'action' }
  }
]
export default {
  mixins: [getArea, getEstate, iconFontComponent],
  data () {
    return {
      visible: false,
      detialVisible: false,
      loading: false,
      detialList: [],
      detialLoading: false,
      type: '1',
      showtime: [],
      region: [],
      options: [],
      formData: [],
      columns,
      form: this.$form.createForm(this, {}),
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        total: 0
      },
      operation_myCharts: null,
      dayList: [],
      dateList: [],
      deviceList: [],
      rankingList: []
    }
  },
  mounted: function () {
    this.load()
  },
  methods: {
    cancel () {
      if (this.operation_myCharts != null && this.operation_myCharts !== '' && this.operation_myCharts !== undefined) {
        this.operation_myCharts.dispose()
      }
    },
    toView (record) {
      this.visible = true
      const params = {
        id: record.estateId,
        type: 2
      }
      getDetail(params).then(res => {
        if (res.code === 0) {
          this.dayList = []
          this.deviceList = []
          this.rankingList = []
          res.result.forEach(item => {
            const itemDay = JSON.parse(JSON.stringify(item.day)).split('-')
            const date = itemDay[1] + '/' + itemDay[2]
            this.dateList = item.day
            this.dayList.push(date)
            this.deviceList.push(item.device)
            this.rankingList.push(item.ranking)
          })
          this.initLine(res.result, record)
        }
      })
    },
    initLine (result, record) {
      const chartDom = document.getElementById('mountNode')
      const operation_myCharts = echarts.init(chartDom)
      this.operation_myCharts = operation_myCharts
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var date = new Date()
            date.getFullYear()
            const times = params[0].axisValue.replace('/', '-')
            // console.log(params[0].axisValue.replace('/', '-'), '时间')
            let str = '<span style="display:inline-block;margin-right:7px;width:3px;height:15px;left:5px;background-color:' + params[0].color + '"></span>' + record.estateName + '<br />'
            str += '<span style="margin-left:10px;">' + '  ' + '<span style="font-size:15px">' + date.getFullYear() + '-' + times + '</span>' + '</span>' + '<br />'
            str += '<span style="margin-left:10px;">' + '运营得分' + '  ' + '<span style="font-size:15px">' + params[0].value + '分' + '</span>' + '</span>' + '<br />'
            str += '<span style="margin-left:10px;">' + '小区排名' + '  ' + '<span style="font-size:15px">' + params[1].value + '名' + '</span>' + '</span>'
            return str
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.dayList
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: this.deviceList,
          type: 'line',
          itemStyle: {
            color: '#1890ff'
          },
          lineStyle: {
            width: 2
          }
        }, {
          data: this.rankingList,
          type: 'line',
          symbolSize: 0, // symbol的大小设置为0
          showSymbol: false, // 不显示symbol
          lineStyle: {
            width: 0, // 线宽是0
            color: 'rgba(0, 0, 0, 0)' // 线的颜色是透明的
          }
        }]
      }
      const listener = function () {
        operation_myCharts.resize()
      }
      window.addEventListener('resize', listener)
      operation_myCharts.setOption(option)
    },
    handleOk (e) {
      console.log(e)
      this.detialVisible = false
    },
    load () {
      this.getArea('', 2)
      this.getEstate()
      this.getTable()
    },
    getTable () {
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        provinceId: this.region[0] || '',
        cityId: this.region[1] || '',
        areaId: this.region[2] || '',
        estateId: this.form.getFieldValue('estateId') || '',
        type: 2
      }
      params.streetId = this.region[3] || ''
      this.loading = true
      getAssessList(params).then(res => {
        this.loading = false
        const result = res.result
        result.list.forEach((item, index) => {
          item['index'] = index + 1
        })
        this.formData = result.list
        this.pagination.total = result.totalCount
      })
    },
    changeArea (areasId) {
      this.estateList = []
      this.form.setFieldsValue({ estateId: undefined })
      if (areasId.length < 4) {
        this.getEstate(areasId)
      } else if (areasId.length === 4) {
        this.getEstate(null, areasId[3])
      }
    },
    toSearch () {
      this.pagination.current = 1
      this.getTable()
    },
    resetForm () {
      this.form.resetFields()
      this.region = []
      // this.estateList = []
      this.form.setFieldsValue({ estateId: undefined })
      this.getTable()
      this.getEstate()
      // this.getTable()
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    handleTableChange (pagination, filters, sorter) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
      this.getTable()
    }
  }
}
</script>

<style lang="stylus" scoped>
.card-container
  .card-title
    span
      font-weight normal
      margin-left 30px
      font-size 14px
</style>
